<div class="container">
  <h1 class="page-title">Consultar Militar</h1>

  <mat-card class="filtro-card">
    <form [formGroup]="form" (ngSubmit)="pesquisar()">
      <div class="form-row">
        <mat-form-field appearance="outline">
          <mat-label>ID Funcional</mat-label>
          <input matInput formControlName="idFuncional"/>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>CPF</mat-label>
          <input matInput formControlName="cpfConsulta"/>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Órgão</mat-label>
          <mat-select formControlName="idOrgao">
            <mat-option *ngFor="let orgao of organizations" [value]="orgao.value">
              {{ orgao.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Matrícula</mat-label>
          <input matInput formControlName="matriculaConsulta"/>
        </mat-form-field>
      </div>

      <div class="form-row-full">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Nome</mat-label>
          <input matInput formControlName="nomeConsulta"/>
        </mat-form-field>
      </div>

      <div class="actions">
        <button mat-raised-button type="submit">Pesquisar</button>
        <button mat-raised-button (click)='limpar()' type="button">Limpar</button>
      </div>
    </form>
  </mat-card>

  <mat-card class="resultados-card">
    <div *ngIf="loading" class="loading-container">
  <mat-spinner diameter="40"></mat-spinner>
</div>
  <table mat-table [dataSource]="beneficiarios" class="mat-elevation-z2" multiTemplateDataRows>

    <!-- ID Funcional -->
    <ng-container matColumnDef="idFuncional">
      <th mat-header-cell *matHeaderCellDef>ID Funcional</th>
      <td mat-cell *matCellDef="let b">{{ b.idFuncional }}</td>
    </ng-container>

    <!-- CPF -->
    <ng-container matColumnDef="cpf">
      <th mat-header-cell *matHeaderCellDef>CPF</th>
      <td mat-cell *matCellDef="let b">{{ b.cpf }}</td>
    </ng-container>

    <!-- Nome -->
    <ng-container matColumnDef="nome">
      <th mat-header-cell *matHeaderCellDef>Nome</th>
      <td mat-cell *matCellDef="let b">{{ b.nome }}</td>
    </ng-container>

    <!-- Matrícula -->
    <ng-container matColumnDef="matricula">
      <th mat-header-cell *matHeaderCellDef>Matrícula</th>
      <td mat-cell *matCellDef="let b">{{ b.matricula }}</td>
    </ng-container>

    <!-- Órgão -->
    <ng-container matColumnDef="orgao">
      <th mat-header-cell *matHeaderCellDef>Órgão</th>
      <td mat-cell *matCellDef="let b">{{ b.orgao.sigla }}</td>
    </ng-container>

    <!-- Ações -->
    <ng-container matColumnDef="acoes">
      <th mat-header-cell *matHeaderCellDef>Ações</th>
      <td mat-cell *matCellDef="let b">
        <button mat-icon-button color="primary" (click)="requerimento(b)">
           <mat-icon>description</mat-icon>
        </button>
      </td>
    </ng-container>

    <!-- Header & Row -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>


  </table>
   <mat-paginator
   [length]="length"
  [pageSize]="10"
  [pageSizeOptions]="[5, 10, 20]"
  (page)="onPageChange($event)">
</mat-paginator>
</mat-card>

</div>
